(function(root){
  'use strict';
  const clamp=(x,a,b)=>Math.max(a,Math.min(b,x));
  class MattMischief {
    constructor(random=Math.random){this.random=random;this.cooldown=0;this.rescueCooldown=25;this.reset();}
    reset(rider){
      if(rider&&['hanging','rescued'].includes(rider.state)){rider.state='falling';rider.age=0;}
      this.latch=null;this.flight=null;this.seen=new Set();this.previous=null;this.fallRoll=false;this.event='';
    }
    unhook(rider){
      this.latch=null;this.cooldown=3.5;
      if(rider.state==='hanging'){rider.state='falling';rider.age=0;rider.body.vy=70;}
    }
    tick(dt,rider,raft,g,bounds,surfaces,pointer,size,enabled=true){
      dt=clamp(dt,0,.05);this.event='';this.cooldown=Math.max(0,this.cooldown-dt);this.rescueCooldown=Math.max(0,this.rescueCooldown-dt);
      if(!enabled||!raft.active||!rider.body.active||!['held','falling','hanging','rescued'].includes(rider.state)){this.reset(rider);return false;}
      const b=rider.body,shoulder=size*.25;
      if(this.flight){
        if(rider.state==='held'){this.flight=null;this.rescueCooldown=90;}
        else {
          const f=this.flight;f.age+=dt;
          if(f.age<.55){const approach=f.age/.55,edge=f.endX<f.startX?bounds.width+180:-180;f.x=edge+(f.startX-edge)*approach;f.y=f.startY+Math.sin(approach*Math.PI)*25;this.previous={state:rider.state,y:b.y};return true;}
          const t=clamp((f.age-.55)/3.6,0,1),ease=t*t*(3-2*t);
          f.x=f.startX+(f.endX-f.startX)*ease;f.y=f.startY+(f.endY-f.startY)*ease-Math.sin(t*Math.PI)*70;
          b.x=f.x;b.y=f.y-7;b.angle=Math.sin(t*Math.PI*2)*.06;b.vx=0;b.vy=0;b.opacity=1;rider.age+=dt;
          if(t===1){this.flight=null;this.rescueCooldown=90;rider.state='falling';rider.age=0;b.vy=20;this.event='The luck dragon drops him gently. Back to making trouble.';}
          this.previous={state:rider.state,y:b.y};return true;
        }
      }
      if(this.latch){
        const l=this.latch,s=surfaces.find(x=>x.id===l.id);
        if(!s||Math.abs(g.x)>.7||g.y<.35){this.unhook(rider);return false;}
        l.x=clamp(l.x,s.x+5,s.x+s.w-5);l.y=s.y;l.age+=dt;
        if(rider.state==='held'&&pointer){
          const dx=pointer.x-l.x,dy=pointer.y+62-(l.y+shoulder+52),distance=Math.hypot(dx,dy);
          l.tension=clamp((distance-32)/105,0,1);l.strain+=Math.max(0,l.tension-.2)*dt;
          if(distance>165||l.strain>.52||l.age>3.8){this.unhook(rider);rider.moveGrip(pointer);this.event='He lost his grip. You win.';return false;}
          // Elastic arm resistance; pointer remains captured by Matt, never by the page button.
          const yieldAmount=.25+l.tension*.42;
          rider.moveGrip({x:l.x+dx*yieldAmount,y:l.y+shoulder+52-62+dy*yieldAmount});
          return false;
        }
        rider.state='hanging';rider.grip=null;rider.age+=dt;
        const tx=l.x+Math.sin(l.age*3.5)*10,ty=l.y+shoulder+52;
        b.vx+=(tx-b.x)*55*dt;b.vy+=(ty-b.y)*55*dt;b.vx*=Math.exp(-9*dt);b.vy*=Math.exp(-9*dt);b.x+=b.vx*dt;b.y+=b.vy*dt;b.angle=Math.sin(l.age*3.5)*.12;
        if(l.age>l.duration){this.unhook(rider);this.event='Couldn’t hang on forever.';}
        this.previous={state:rider.state,y:b.y};return true;
      }
      if(rider.state==='falling'&&this.previous?.state!=='falling')this.fallRoll=this.random()<.055;
      const visible=b.y>bounds.top+60&&b.y<bounds.top+bounds.viewHeight-70;
      if(rider.state==='falling'&&this.fallRoll&&!this.rescueCooldown&&rider.age>.65&&visible&&g.y>.35){
        this.fallRoll=false;this.flight={age:0,startX:b.x,startY:b.y+7,endX:clamp(b.x<bounds.width/2?bounds.width*.78:bounds.width*.22,75,bounds.width-75),endY:Math.min(bounds.height-60,bounds.top+bounds.viewHeight*.72),x:b.x,y:b.y+7};
        rider.state='rescued';rider.grip=null;rider.age=0;this.event='Rare luck-dragon rescue. Hang on, Matt!';return true;
      }
      if(!this.cooldown&&g.y>.35&&Math.abs(g.x)<.7&&['held','falling'].includes(rider.state)){
        for(const s of surfaces){
          const nearX=b.x>s.x-12&&b.x<s.x+s.w+12;
          const dy=b.y-shoulder-s.y;
          const crossed=this.previous&&this.previous.y-shoulder<=s.y+32&&dy>=12&&b.vy>25;
          const near=nearX&&(rider.state==='held'?Math.abs(dy-22)<28:crossed&&dy<85);
          if(!near){this.seen.delete(s.id);continue;}
          if(this.seen.has(s.id))continue;this.seen.add(s.id);
          if(this.random()>(rider.state==='held'?.3:.18))continue;
          this.latch={id:s.id,x:clamp(b.x,s.x+8,s.x+s.w-8),y:s.y,age:0,strain:0,tension:0,duration:1.8+this.random()*2.2};
          b.vx*=.2;b.vy*=.2;
          if(rider.state==='falling'){rider.state='hanging';rider.age=0;}
          this.event='He grabbed a button. Keep pulling, or let him hang.';break;
        }
      }
      this.previous={state:rider.state,y:b.y};return false;
    }
  }
  if(typeof module!=='undefined'&&module.exports)module.exports=MattMischief;else root.NyeMattMischief=MattMischief;
})(typeof window!=='undefined'?window:globalThis);
